import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { naira, compactNaira } from "../../lib/format";
import { FileDown, FileText } from "lucide-react";
import { C } from "./AccountingLayout";
import { downloadReport } from "./exportHelpers";

export default function AccountsPayable() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => { api.get("/reports/aged-payables").then(setD).catch(() => {}); }, []);
  const doExport = async (fmt) => {
    setBusy(fmt);
    const date = new Date().toISOString().slice(0, 10);
    await downloadReport(`/reports/exports/aged-payables.${fmt}`, `aged-payables-${date}.${fmt}`);
    setBusy(null);
  };
  if (!d) return <div className="rounded-xl bg-white border p-8 text-center" style={{ borderColor: C.border, color: C.softMuted }}>Loading…</div>;
  const b = d.buckets;
  return (
    <div className="space-y-4" data-testid="ap-page">
      <div className="flex justify-end gap-2">
        <button onClick={() => doExport("csv")} disabled={busy === "csv"} className="h-9 px-3 text-[12px] font-semibold rounded-md flex items-center gap-1.5 disabled:opacity-50" style={{ background: C.gold, color: "#FFFFFF" }} data-testid="ap-export-csv"><FileDown size={13} /> {busy === "csv" ? "…" : "CSV"}</button>
        <button onClick={() => doExport("pdf")} disabled={busy === "pdf"} className="h-9 px-3 text-[12px] font-semibold rounded-md flex items-center gap-1.5 disabled:opacity-50 text-white" style={{ background: C.burgundy }} data-testid="ap-export-pdf"><FileText size={13} /> {busy === "pdf" ? "…" : "PDF"}</button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {[
          { label: "Current (0-30)", val: b.current, color: C.text },
          { label: "Due (31-60)", val: b.due_30_60, color: C.text },
          { label: "Overdue (61-90)", val: b.overdue_61_90, color: C.red },
          { label: "Overdue (90+)", val: b.overdue_90p, color: C.red },
          { label: "Total AP", val: b.total, color: C.burgundy },
        ].map((r, i) => (
          <div key={i} className="rounded-xl bg-white border p-4" style={{ borderColor: C.border }}>
            <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: C.muted }}>{r.label}</div>
            <div className="font-brand font-bold text-2xl mt-1" style={{ color: r.color }}>{compactNaira(r.val)}</div>
          </div>
        ))}
      </div>
      <div className="rounded-xl bg-white border overflow-hidden" style={{ borderColor: C.border }}>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] uppercase tracking-widest border-b" style={{ color: C.softMuted, borderColor: C.borderSoft }}>
              <th className="py-3 px-4">PO</th><th className="py-3 px-3">Supplier</th><th className="py-3 px-3">Due</th>
              <th className="py-3 px-3">Days</th><th className="py-3 px-3 text-right">Total</th>
              <th className="py-3 px-3 text-right">Paid</th><th className="py-3 px-3 text-right">Outstanding</th><th className="py-3 px-4">Status</th>
            </tr></thead>
            <tbody>{d.rows.length === 0 ? <tr><td colSpan={8} className="py-8 text-center" style={{ color: C.softMuted }}>No outstanding payables.</td></tr> : d.rows.map((r, i) => {
              const overdue = r.days_past_due > 30;
              return (
                <tr key={i} className="border-b" style={{ borderColor: C.borderSoft }}>
                  <td className="py-2.5 px-4 font-semibold" style={{ color: C.burgundy }}>{r.po_number}</td>
                  <td className="py-2.5 px-3 text-[12.5px]" style={{ color: C.text }}>{r.supplier_name}</td>
                  <td className="py-2.5 px-3 text-[12px]" style={{ color: C.muted }}>{(r.due_date || "").slice(0, 10)}</td>
                  <td className="py-2.5 px-3 text-[12px] font-semibold" style={{ color: overdue ? C.red : C.muted }}>{r.days_past_due}d</td>
                  <td className="py-2.5 px-3 text-right tabular-nums">{naira(r.total)}</td>
                  <td className="py-2.5 px-3 text-right tabular-nums" style={{ color: C.green }}>{naira(r.paid)}</td>
                  <td className="py-2.5 px-3 text-right tabular-nums font-brand font-bold" style={{ color: C.text }}>{naira(r.outstanding)}</td>
                  <td className="py-2.5 px-4"><span className="text-[10px] font-bold px-2 py-1 rounded-full" style={{ background: overdue ? C.redTint : C.amberTint, color: overdue ? C.red : "#8B5E14" }}>{overdue ? "Overdue" : r.status}</span></td>
                </tr>
              );
            })}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
